<template>
  <div class="empty">
    <div v-if="imgHidden">
      <img v-if="emptyImg==='null-search'" src="@/assets/img/null-search.png">
      <img v-if="emptyImg==='null-list'" src="@/assets/img/null-list.png">
      <img v-if="emptyImg==='null-article'" src="@/assets/img/null-article.png">
      <img v-if="emptyImg==='null-url'" src="@/assets/img/null-url.png">
      <img v-if="emptyImg==='404'" src="@/assets/img/404.png">
    </div>
    <div class="empty-info">
      <span class="empty-info-line"></span>
      <span class="empty-info-text">{{ emptyText }}</span>
      <span class="empty-info-line"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "empty-index",
  props: {
    imgHidden:{
      type:Boolean,
      default: true,
    },
    emptyText: {
      type: String,
      default: "没有数据"
    },
    emptyImg: {
      type: String,
      default: "null-search"
    },
  }
}
</script>


<style lang="scss">
.empty {
  margin: 0 auto;
  max-width: 360px;
  padding: 20px;

  img {
    width: 100%;
  }

  .empty-info {
    padding: 10px;
    display: flex;
    color: #999;
    align-items: center;

    * {
      display: inline-block;
    }

    .empty-info-line {
      flex: 1;
      height: 1px;
      background-color: #eee;
    }

    .empty-info-text {
      margin: 0 10px;
      font-size: 14px;
    }
  }
}

</style>
